import { render, staticRenderFns } from "./AccidentIncidentYearlyTable.vue?vue&type=template&id=31439916&scoped=true&"
import script from "./AccidentIncidentYearlyTable.vue?vue&type=script&lang=js&"
export * from "./AccidentIncidentYearlyTable.vue?vue&type=script&lang=js&"
import style0 from "./AccidentIncidentYearlyTable.vue?vue&type=style&index=0&id=31439916&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31439916",
  null
  
)

export default component.exports